<template>
    <v-dialog
        content-class="border-radius-3"
        v-model="dialog"
        persistent
        max-width="1000"
        :retain-focus="false"
        overlay-color="primary"
        overlay-opacity="0.75"
    >
        <v-card v-resize="onResize">
            <v-card-title class="py-0 my-0">
                <v-btn
                    color="#302656"
                    :class="buyData.isAvatarPack ?
                        'border-radius-1 no-uppercase text-body-1 white--text btn-l-2' :
                        'border-radius-1 no-uppercase text-body-1 white--text btn-l'"
                    width="250"
                    height="60"
                    elevation="4"
                    @click="closeModal"
                    :loading="btnFavLoading"
                >
                    <v-icon class="mr-2">mdi-undo-variant</v-icon>
                    {{ $t('store.return') }}
                </v-btn>
                <v-card
                    width="250"
                    height="60"
                    elevation="4"
                    :class="buyData.isAvatarPack ?
                        'py-2 border-radius-1 color-text text-body-1 btn-r-2' :
                        'py-2 border-radius-1 color-text text-body-1 btn-r'"
                >
                    <v-row align="center" justify="center">
                        <v-img src="/img/user/beecoin-3.svg" height="40" max-width="40" class="mr-2"></v-img>
                        {{ $t('profile.you_have') }}
                        <span class="font-weight-bold mx-1">
                            {{ coins }} Beecoins
                        </span>
                    </v-row>
                </v-card>
                <v-row justify="end" class="mx-6">
                    <v-btn icon class="favorite-btn" @click="setFavorite">
                        <v-img
                            src="/img/user/ribbon.svg"
                            height="120"
                            max-width="60"
                        >
                            <v-img src="/img/user/icon-favorite.svg" class="mt-3" height="60" max-width="60" v-show="!favorite"></v-img>
                            <v-img src="/img/user/icon-favorite-selected.svg" class="mt-3" height="60" max-width="60" v-show="favorite"></v-img>
                        </v-img>
                    </v-btn>
                </v-row>
            </v-card-title>
            <v-card-text
                :class="buyData.isAvatarPack ? 'card-text-2 pb-0' : 'card-text pb-0'"
            >
                <v-row v-if="buyData.value">
                    <v-col cols="12" sm="6" md="4" lg="4" class="pa-0">
                        <v-row justify="center" class="mx-0 px-0 pb-0" v-if="buyData.isAvatarPack">
                            <v-col cols="12">
                                <v-row justify="center" class="f-row">
                                    <img
                                        :src="`https://assets.beereaders.com/avatar/${buyData.value.avatarDTOList[0].name}/${buyData.value.avatarDTOList[0].value}`"
                                        class="avatar-img-top transition-all"
                                        alt="Av"
                                    />
                                </v-row>
                                <v-row justify="center" class="s-row">
                                    <v-col cols="6">
                                        <img
                                            :src="`https://assets.beereaders.com/avatar/${buyData.value.avatarDTOList[1].name}/${buyData.value.avatarDTOList[1].value}`"
                                            class="avatar-img-r transition-all"
                                            alt="Av"
                                        />
                                    </v-col>
                                    <v-col cols="6">
                                        <img
                                            :src="`https://assets.beereaders.com/avatar/${buyData.value.avatarDTOList[2].name}/${buyData.value.avatarDTOList[2].value}`"
                                            class="avatar-img-l transition-all"
                                            alt="Av"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row justify="center" class="mx-0 px-0 my-xl-7" v-if="buyData.isBook">
                            <v-img
                                :src="`https://assets.beereaders.com/lbr/image/${buyData.value.resourceDir}/cover_small.jpg`"
                                :height="imgSize"
                                :max-width="imgSize*0.8"
                                class="ma-2 book-skin-img"
                            />
                        </v-row>
                        <v-row justify="center" class="mx-0 px-0 my-xl-7" v-if="buyData.isSkin">
                            <v-img
                                :src="`https://assets.beereaders.com/skins/${getThumbnail(buyData.value)}`"
                                :height="imgSize"
                                :max-width="imgSize"
                                class="ma-2 book-skin-img"
                            />
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8" class="pa-0 pr-md-6">
                        <v-row justify="start" class="my-2 mx-1 color-text text-h6" v-if="buyData.isAvatarPack">
                            {{ $t('store.pack_of') }}
                            {{ buyData.value.avatarDTOList.length }}
                            {{ $t('store.avatars') }}
                        </v-row>
                        <v-row justify="start" class="my-2 mx-1 color-text text-h6" v-if="buyData.isBook">
                            {{ buyData.value.author }}
                        </v-row>
                        <v-row class="my-6" v-if="buyData.isSkin" />
                        <p class="color-text text-left text-h4 pr-md-12">
                            {{ buyData.isBook ? buyData.value.title : buyData.value.name }}
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions
                :class="buyData.isAvatarPack ? 'pt-12 pb-0 pb-md-6 px-12 card-actions-2' : 'pt-12 pb-0 pb-md-6 px-12 card-actions'"
            >
                <v-row align="center" justify="center" justify-md="end" class="mr-12">
                    <p class="pt-4 pt-sm-2 px-2 color-text text-left text-h5">
                        {{ priceText }}
                        <br v-if="!($vuetify.breakpoint.xs||$vuetify.breakpoint.sm)" />
                        {{ $t('store.cost') }}
                    </p>
                    <v-img
                        class="mx-4"
                        src="/img/user/bg-price.svg"
                        :max-height="priceIconSize/3"
                        :max-width="priceIconSize/3.3"
                        v-if="buyData.value"
                    >
                        <v-row class="text-price color-price font-weight-bold" justify="center">
                            {{ buyData.isAvatarPack ? packPrice : buyData.value.price }}
                        </v-row>
                        <v-row class="color-price coins text-beecoins" justify="center">
                            Beecoins
                        </v-row>
                    </v-img>
                    <v-btn
                        color="secondary"
                        class="mx-6 my-2 no-uppercase text-h6"
                        width="300"
                        x-large
                        rounded
                        @click="toBuy"
                        :loading="btnLoading"
                        :disabled="coins<(buyData.isAvatarPack?packPrice:bookOrSkinPrice)"
                    >
                        {{ buyText }}
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import AvatarFavoriteService from '../../services/avatarFavorite'
import BookUserFavoriteService from '../../services/bookUserFavorite'
import GamificationService from '../../services/gamification'
import PurchaseService from '../../services/purchase'
import SkinFavoriteService from '../../services/skinFavorite'

const defaultData = {
    isAvatarPack: false,
    isBook: false,
    isSkin: false,
    value: null
}

export default {
    props: {
        buyData: { type: Object, default: defaultData },
        dialog: { type: Boolean, default: false }
    },
    data() {
        return {
            bought: false,
            btnFavLoading: false,
            btnLoading: false,
            favorite: false,
            imgSize: 300,
            reload: 0,
            selectedSkin: {},
            priceIconSize: 300,
            windowSize: {
                x: 0,
                y: 0
            }
        }
    },
    mounted() {
        this.onResize()
    },
    computed: {
        ...mapState({
            userId: (state) => state.userData.user.id,
            coins: (state) => state.userData.coins
        }),
        buyText() {
            if (this.buyData.isAvatarPack) return this.$t('store.buy_this_pack')
            if (this.buyData.isBook) return this.$t('store.buy_this_book')
            return this.$t('store.buy_this_skin')
        },
        packPrice() {
            let price = 0
            this.buyData.value.avatarDTOList.forEach(element => {
                price += element.price
            });
            return price
        },
        priceText() {
            if (this.buyData.isAvatarPack) return this.$t('store.this_pack')
            if (this.buyData.isBook) return this.$t('store.this_book')
            return this.$t('store.this_skin')
        },
        bookOrSkinPrice() {
            return this.buyData.value ? this.buyData.value.price : 0
        }
    },
    methods: {
        ...mapActions('userData', [
            'setGamification',
        ]),
        closeModal () {
            this.$emit('close', this.bought)
            this.bought = false
        },
        async getGamification () {
            GamificationService.getUserGameStatsByUser(
                this.userId
            )
            .then((response) => {
                if (response.content.id) {
                    this.setGamification(response.content)
                }
            })
            .catch((error) => console.error(error))
        },
        getThumbnail(skin) {
            const img = skin.resources.find((res) => res.resourceUrl.includes('thumbnail'))
            return img.resourceUrl
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            if (this.windowSize.y < 725) {
                this.imgSize = 220
                this.priceIconSize = 180
                return
            }
            if (this.windowSize.y < 835) {
                this.imgSize = 220
                this.priceIconSize = 220
                return
            }
            this.imgSize = 280
            this.priceIconSize = 280
        },
        async setFavorite () {
            this.btnFavLoading = true
            this.favorite = !this.favorite
            if (this.buyData.isAvatarPack) {
                await this.setFavoriteAvatarPack()
            }
            if (this.buyData.isBook) {
                await this.setFavoriteBook()
            }
            await this.setFavoriteSkin()
            this.btnFavLoading = false
        },
        async setFavoriteAvatarPack () {
            if (this.favorite) {
                await AvatarFavoriteService.createFavorite(
                    this.userId,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            } else {
                await AvatarFavoriteService.deleteFavorite(
                    this.userId,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            }
            this.$emit('favorite', 0)
        },
        async setFavoriteBook () {
            if (this.favorite) {
                await BookUserFavoriteService.addFavoriteBookToUser({
                    user: { id: this.userId },
                    book: { id: this.buyData.value.id }
                })
                .catch((error) => console.error(error))
            } else {
                await BookUserFavoriteService.deleteFavoriteBookToUser(
                    this.userId,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            }
            this.$emit('favorite', 1)
        },
        async setFavoriteSkin () {
            if (this.favorite) {
                await SkinFavoriteService.createFavorite(
                    this.userId,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            } else {
                await SkinFavoriteService.deleteFavorite(
                    this.userId,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            }
            this.$emit('favorite', 2)
        },
        async toBuy () {
            this.btnLoading = true
            this.bought = true
            if (this.buyData.isAvatarPack) {
                await PurchaseService.createPurchaseAvatarPack(
                    this.userId,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            }
            if (this.buyData.isBook) {
                await PurchaseService.createPurchaseBook(
                    this.userId,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            }
            if (this.buyData.isSkin) {
                await PurchaseService.createPurchaseSkin(
                    this.userId,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            }
            await this.getGamification()
            this.btnLoading = false
            this.closeModal()
        }
    },
    watch: {
        dialog() {
            if (this.dialog) {
                this.favorite = this.buyData.value.favorite
            }
        }
    }
}
</script>

<style scoped>
.color-primary {
    color: #514773;
}
.color-text {
    color: #4A3216;
}
.color-price {
    color: #DF820D;
}
.coins {
    margin-top: -5px;
}
.price-avatar {
    margin-top: 180px;
}
.price-skin {
    margin-top: 60px;
}
.text-price {
    font-size: .75rem;
    margin-top: 5px;
}
.text-beecoins {
    font-size: .65rem;
    margin-top: -15px;
}

@media (min-height: 500px) {
    .price-avatar {
        margin-top: 50px;
    }
    .price-skin {
        margin-top: 60px;
    }
    .text-price {
        font-size: .75rem;
        margin-top: 15px;
    }
    .text-beecoins {
        font-size: .65rem;
        margin-top: -5px;
    }
}
@media (min-height: 670px) {
    .price-avatar {
        margin-top: 80px;
    }
    .price-skin {
        margin-top: 90px;
    }
    .text-price {
        font-size: .75rem;
        margin-top: 15px;
    }
    .text-beecoins {
        font-size: .65rem;
        margin-top: -5px;
    }
}
@media (min-height: 725px) {
    .price-avatar {
        margin-top: 130px;
    }
    .price-skin {
        margin-top: 120px;
    }
    .text-price {
        font-size: .9rem;
        margin-top: 20px;
    }
    .text-beecoins {
        font-size: .8rem;
        margin-top: -10px;
    }
}
@media (min-height: 835px) {
    .price-avatar {
        margin-top: 170px;
    }
    .price-skin {
        margin-top: 150px;
    }
    .text-price {
        font-size: 1.25rem;
        margin-top: 20px;
    }
    .text-beecoins {
        font-size: 1rem;
        margin-top: -5px;
    }
}

.no-uppercase {
     text-transform: none;
}
.book-skin-img {
    display: block;
    width: 100%;
    border-radius: 20px;
}

.f-row {
    height: 200px;
}
.s-row {
    height: 200px;
    margin-top: -70px;
}
.avatar-img-top {
    display: block;
    height: 80%;
    width: 50%;
    z-index: 1;
}
.avatar-img-r {
    display: block;
    height: 80%;
    margin-left: 30px;
    width: 100%;
}
.avatar-img-l {
    display: block;
    height: 80%;
    margin-left: -30px;
    width: 100%;
}
.ribbon-icon {
    margin-top: -16px;
}
.favorite-btn {
    margin-top: 40px;
    transform: none;
}

.favorite-btn:hover {
  color: #FF6F3A;
  background-color: #FF6F3A;
  transform: none;
}

.favorite-btn:focus {
  color: #FF6F3A;
  background-color: #FF6F3A;
  transform: none;
}

.favorite-btn:active {
  color: #FF6F3A;
  background-color: #FF6F3A;
  transform: none;
}
.card-text {
    margin-top: -40px;
}
.card-text-2 {
    margin-top: -40px;
}
.card-actions {
    margin-top: -60px;
}
.card-actions-2 {
    margin-top: -60px;
}

.btn-l {
    position: fixed;
    top: 9%;
    left: 4%;
}
.btn-l-2 {
    position: fixed;
    top: 9%;
    left: 4%;
}
.btn-r {
    position: fixed;
    top: 9%;
    right: 4%;
}
.btn-r-2 {
    position: fixed;
    top: 9%;
    right: 4%;
}

@media (min-width: 1100px) {
    .btn-l {
        left: 6%;
    }
    .btn-l-2 {
        left: 6%;
    }
    .btn-r {
        right: 6%;
    }
    .btn-r-2 {
        right: 6%;
    }
}
@media (min-width: 1150px) {
    .btn-l {
        left: 9%;
    }
    .btn-l-2 {
        left: 9%;
    }
    .btn-r {
        right: 9%;
    }
    .btn-r-2 {
        right: 9%;
    }
}
@media (min-width: 1250px) {
    .btn-l {
        left: 12%;
    }
    .btn-l-2 {
        left: 12%;
    }
    .btn-r {
        right: 12%;
    }
    .btn-r-2 {
        right: 12%;
    }
}
@media (min-width: 1350px) {
    .btn-l {
        left: 15%;
    }
    .btn-l-2 {
        left: 15%;
    }
    .btn-r {
        right: 15%;
    }
    .btn-r-2 {
        right: 15%;
    }
}
@media (min-width: 1450px) {
    .btn-l {
        left: 18%;
    }
    .btn-l-2 {
        left: 18%;
    }
    .btn-r {
        right: 18%;
    }
    .btn-r-2 {
        right: 18%;
    }
}
@media (min-width: 1600px) {
    .btn-l {
        left: 21%;
    }
    .btn-l-2 {
        left: 21%;
    }
    .btn-r {
        right: 21%;
    }
    .btn-r-2 {
        right: 21%;
    }
}
@media (min-width: 1750px) {
    .btn-l {
        left: 24%;
    }
    .btn-l-2 {
        left: 24%;
    }
    .btn-r {
        right: 24%;
    }
    .btn-r-2 {
        right: 24%;
    }
}

@media (min-height: 650px) {
    .btn-l, .btn-r {
        top: 16%;
    }
    .btn-l-2, .btn-r-2 {
        top: 11%;
    }
    .card-text-2 {
        margin-top: -50px;
    }
    .card-actions {
        margin-top: -120px;
    }
    .card-actions-2 {
        margin-top: -160px;
    }
}
@media (min-height: 700px) {
    .btn-l, .btn-r {
        top: 20%;
    }
    .btn-l-2, .btn-r-2 {
        top: 20%;
    }
    .card-actions {
        margin-top: -130px;
    }
    .card-actions-2 {
        margin-top: -130px;
    }
}
@media (min-height: 750px) {
    .btn-l, .btn-r {
        top: 20%;
    }
    .btn-l-2, .btn-r-2 {
        top: 20%;
    }
}
@media (min-height: 800px) {
    .btn-l, .btn-r {
        top: 12%;
    }
    .btn-l-2, .btn-r-2 {
        top: 12%;
    }
}
@media (min-height: 850px) {
    .btn-l, .btn-r {
        top: 14%;
    }
    .btn-l-2, .btn-r-2 {
        top: 14%;
    }
}
@media (min-height: 900px) {
    .btn-l, .btn-r {
        top: 24%;
    }
    .btn-l-2, .btn-r-2 {
        top: 24%;
    }
    .card-text {
        margin-top: -70px;
    }
    .card-text-2 {
        margin-top: -70px;
    }
    .card-actions {
        margin-top: -160px;
    }
    .card-actions-2 {
        margin-top: -160px;
    }
}
@media (min-height: 1000px) {
    .btn-l, .btn-r {
        top: 19%;
    }
    .btn-l-2, .btn-r-2 {
        top: 19%;
    }
}
</style>
